module.exports = __webpack_public_path__ + "3e848db7bd34d7cc6e1b66155668e43c.gif";